import { useState } from "react";
import { CheckCircle2, Loader2 } from "lucide-react";
import { http, errMsg } from "../lib/api";
import { RequestFields, BLANK_REQUEST } from "../components/bespoke/RequestFields";

export default function PlanTrip() {
  const [f, setF] = useState(BLANK_REQUEST);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try { await http.post("/bespoke/requests", f); setDone(true); }
    catch (ex) { setErr(errMsg(ex)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen bg-[#FAF9F6] text-[#2B2A26]" style={{ fontFamily: "'Poppins', sans-serif" }} data-testid="plan-trip-page">
      <div className="max-w-3xl mx-auto px-6 py-16">
        <div className="text-xs uppercase tracking-[0.3em] text-[#9A7B2C] mb-4">PB Travel Angel · Bespoke</div>
        <h1 className="text-4xl sm:text-5xl font-semibold leading-tight mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>Plan My Trip</h1>
        <p className="text-base text-stone-600 max-w-xl mb-12">Tell us about your trip and we'll research and write a kit just for you — your dates, your pace, your kind of places. We'll reply within two business days with a quote.</p>
        {done ? (
          <div data-testid="plan-trip-success" className="rounded-xl border border-[#C9A847]/40 bg-white p-10 text-center">
            <CheckCircle2 className="mx-auto text-[#9A7B2C] mb-4" size={40} />
            <h2 className="text-2xl mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>Thank you — your request is with us.</h2>
            <p className="text-stone-600">We'll be in touch at {f.email} soon. Questions? support@pbtravelangel.com</p>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="plan-trip-form" className="space-y-8">
            <RequestFields value={f} onChange={setF} />
            {err && <div data-testid="plan-trip-error" className="text-sm text-red-600">{err}</div>}
            <button data-testid="plan-trip-submit" disabled={busy} className="inline-flex items-center gap-2 rounded-full bg-[#2B2A26] text-white px-8 py-4 font-medium hover:bg-black transition-colors disabled:opacity-60">
              {busy && <Loader2 size={16} className="animate-spin" />} Send my request
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
